import React from 'react';
import { withRouter } from 'react-router-dom';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Input, message, Modal } from 'antd';
import styles from './index.module.less';
import { $postJSON } from '@/utils/http';

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};
// 修改密码弹窗
const ModifyPassModal = (props) => {
  const { getFieldDecorator, resetFields } = props.form;
  const { isModifyPassModalShow, handleModifyPassModalClose } = props;

  // 点击取消按钮
  const handleCancle = () => {
    resetFields();
    handleModifyPassModalClose();
  };
  // // 登录失效回调
  // const invaidSessionCallback = () => {
  //   message.error('您尚未登录, 请先登录！');
  //   history.push('/smart/login');
  // };
  // // 密码修改失败回调
  // const failCallback = ({ errmsg = '' }) => {
  //   message.error(errmsg);
  // };
  // // 密码修改成功回调
  // const succCallback = () => {
  //   message.error('新密码设置成功，请重新登录！');
  //   history.push('/smart/login');
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();
    props.form.validateFields(async (err, values) => {
      const { npwd, opwd, rePwd, token } = values;
      if (rePwd !== npwd) {
        message.error('两次新密码输入不一致！');
        return;
      }
      if (!/(?!^(\d+|[a-zA-Z]+|[~!@#$%^&*?]+)$)^[\w~!@#$%^&*?]{8,20}$/.test(npwd)) {
        message.error('新密码最少8位字符，包含字母、数字、符号 _!@#$%^&* 中的任意两项！');
        return;
      }
      if (!err) {
        // window._PASSICSDK.modifyPwd(opwd, npwd, succCallback, invaidSessionCallback, failCallback);
        const modifyPwd = (params = {}) =>
          $postJSON({ url: '/smart/web/account/modifypassword', params });
        await modifyPwd({ newPass: npwd, oldPass: opwd });
      }
    });
  };
  return (
    <Modal
      className={styles.modalWarp}
      title="修改密码"
      visible={isModifyPassModalShow}
      onOk={handleSubmit}
      onCancel={handleCancle}
    >
      <Form {...formItemLayout} onSubmit={handleSubmit} className="login-form">
        <Form.Item label="旧密码">
          {getFieldDecorator('opwd', {
            rules: [{ required: true, message: '请输入旧密码!' }],
          })(<Input.Password placeholder="输入旧密码" />)}
        </Form.Item>
        <Form.Item label="新密码">
          {getFieldDecorator('npwd', {
            rules: [
              { required: true, message: '请输入新密码!' },
              { whitespace: true, message: '不能输入空格!' },
              { min: 8, message: '长度不能少于8位!' },
            ],
          })(<Input.Password placeholder="输入新密码" />)}
        </Form.Item>
        <Form.Item label="确认新密码">
          {getFieldDecorator('rePwd', {
            rules: [
              { required: true, message: '请再次输入新密码!' },
              { whitespace: true, message: '不能输入空格!' },
              { min: 8, message: '长度不能少于8位!' },
            ],
          })(<Input.Password placeholder="请再次输入新密码" />)}
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default withRouter(Form.create()(ModifyPassModal));
